export default "__VITE_ASSET__DQLjAalt__"